import { render } from "./WCNavBar.vue?vue&type=template&id=573f44b1&scoped=true"
import script from "./WCNavBar.vue?vue&type=script&lang=js"
export * from "./WCNavBar.vue?vue&type=script&lang=js"

import "./WCNavBar.vue?vue&type=style&index=0&id=573f44b1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573f44b1"]])

export default __exports__